import { FC, useCallback, useMemo } from "react"

import { Skeleton } from "antd";
import { Collapse, CollapseItem } from "@hdi-seguros/web-components.collapse";

import { AseguradoPoliza, Car, Endorsement, InsurancePolicy, LifePossession, Possessions, PossessionsType, Ubication, Vessel } from "../../../../../shared/interfaces";
import { CarPossessionsCollapsable, LifePossessionsCollapsable, VariousRiskPossessionsCollapsable, VesselsPossessionsCollapsable } from "./components";

interface CollapsablePossessionProps {
    possessionData: Car | Vessel | LifePossession | Ubication;
    isLoading?: boolean;
    type: PossessionsType;
    insurancePolicyDetail: InsurancePolicy;
    endorsement?: Endorsement;
    insuredsByPolicy?: AseguradoPoliza;
    possessions?: Possessions[] | any;
}

export const CollapsablePossession: FC<CollapsablePossessionProps> = ({ possessionData, isLoading = false, type, insurancePolicyDetail, endorsement, insuredsByPolicy, possessions }) => {

    const collapsableLabel = useMemo(() => {
        if( type === PossessionsType.BIENES_AUTOS ) {
            return `${ (possessionData as Car).descripcionInfoAuto } - ${ (possessionData as Car).patente }`
        }

        if( type === PossessionsType.BIENES_EMBARCACIONES ) {
            return ( possessionData as Vessel ).matricula
        }

        if( type === PossessionsType.BIENES_RIESGOS_VARIOS ) {
            return (possessionData as Ubication).direccion;
        }

        if( type === PossessionsType.BIENES_VIDA ) {
            return (possessionData as LifePossession).integrVida
        }

        return '';
    }, [type, possessionData]);

    const getChildren = useCallback(() => {
        if( type === PossessionsType.BIENES_AUTOS ) {
            return <CarPossessionsCollapsable possessionInfo={ possessionData as Car } insurancePolicyDetail={ insurancePolicyDetail } endorsement={endorsement} 
                                                insuredsByPolicy={insuredsByPolicy} possessions={possessions} />
        }

        if( type === PossessionsType.BIENES_EMBARCACIONES ) {
            return <VesselsPossessionsCollapsable possessionInfo={ possessionData as Vessel } insurancePolicyDetail={ insurancePolicyDetail } />
        }

        if( type === PossessionsType.BIENES_RIESGOS_VARIOS ) {
            return <VariousRiskPossessionsCollapsable possessionInfo={ possessionData as Ubication } insurancePolicyDetail={ insurancePolicyDetail } />;
        }

        if( type === PossessionsType.BIENES_VIDA ) {
            return <LifePossessionsCollapsable possessionInfo={ possessionData as LifePossession } insurancePolicyDetail={ insurancePolicyDetail } />
        }

        return <></>
    }, [ type, possessionData, insurancePolicyDetail ])

    const item: Array<CollapseItem> = useMemo(() => [
        {   
            key: collapsableLabel,
            label: collapsableLabel,
            children: getChildren(),
        },
    ], [collapsableLabel, getChildren]);

    if( isLoading ) return <Skeleton.Input active style={{ width: '100%', marginBottom: 15 }} block size="large" />

    return (
        <Collapse
            items={ item }
            style={{ marginBottom: 15 }}
        />
    )
}
